import React, { useState } from 'react';
import { Navigate } from 'react-router-dom'

import './Homepage.css';

function Homepage({ socket, identity, setIdentity}) {

    const [value, setValue] = useState('');
    const [roomCode, setRoomCode] = useState(null)
    
    const submitForm = (e) => {
        e.preventDefault();
        var msg = {code: 'abcdef', name: value}
        socket.emit('joinRoom', JSON.stringify(msg))
        setValue('');
        socket.on('identify', (message) => {
            console.log("Rec'd identity " + message)
            const msg = JSON.parse(message)
            setRoomCode(msg.room)
            setIdentity(msg)
            socket.off('identify')
        })
    };

    if(roomCode) return <Navigate to={'/play/'+roomCode}/>
    return (
        <div className="App">
            {socket ? (
                <div>
                    <p>Tile Flippers!</p>
                    <form onSubmit={submitForm}>
                        <input
                            autoFocus
                            value={value}
                            placeholder="Enter your name"
                            onChange={(e) => {
                                setValue(e.currentTarget.value);
                            }}
                        />
                    </form>
                </div>
            ) : (
                <div>Not Connected</div>
            )}
        </div>
    );
}

export default Homepage;